import React, { useRef, useState, useEffect } from 'react';
import anime from 'animejs/lib/anime.es.js';
import { gtmTracking } from '../../js/helpers';
import './SocialShare.scss'

const SocialShare = () => {
  const tooltipRef = useRef();
  const tooltipShareContentRef = useRef();
  const shareUrlRef = useRef();

  const [toggleSocialTooltip, settoggleSocialTooltip] = useState(false);
  const [toggleCopyTooltip, settoggleCopyTooltip] = useState(false);

  const hidePopupHandler = () => {
    settoggleCopyTooltip(true);
    setTimeout(() => {
      settoggleCopyTooltip(false);
    }, 1500);
  };

  const copyToClipboardHandler = async () => {
    if ('clipboard' in navigator) {
      await navigator.clipboard.writeText(window.location.href);
      hidePopupHandler();
    } else {
      shareUrlRef.current.select();
      document.execCommand('copy');
      hidePopupHandler();
    }
  };

  const shareTooltipHandler = () => {
    settoggleSocialTooltip(() => !toggleSocialTooltip);
  };

  const changeHandler = (e) => {
    if (!tooltipRef.current.contains(e.target)) {
      settoggleSocialTooltip(false);
    }
  };

  useEffect(() => {
    if (!toggleSocialTooltip) {
      return;
    }

    anime({
      targets: tooltipShareContentRef.current,
      opacity: [0, 1],
      easing: 'easeOutExpo',
    });

    document.addEventListener('click', changeHandler);
    return () => document.removeEventListener('click', changeHandler);
    
  }, [toggleSocialTooltip]);

  const classActive = toggleSocialTooltip ? 'tos-footer__button--active' : '';
  // const ogTitle = document.querySelector('meta[property="og:title"]').content ?? '';
  const ogTitle = '';

  const shareLinkedin = () => {
    gtmTracking('share', 'linkedin', 'share content');
    window.open('https://www.linkedin.com/sharing/share-offsite/?url=' + window.window.location.href + '&title=' + ogTitle, '', '_blank, width=500, height=500, resizable=yes, scrollbars=yes'); return false;
  }

  const shareTwitter = () => {
    gtmTracking('share', 'twitter', 'share content');
    window.open('https://twitter.com/share?url=' + window.window.location.href + '&text=' + ogTitle, '', '_blank, width=500, height=500, resizable=yes, scrollbars=yes'); return false;
  }

  const shareFacebook = () => {
    gtmTracking('share', 'facebook', 'share content');
    window.open('https://www.facebook.com/sharer.php?u=' + window.window.location.href, '', '_blank, width=500, height=500, resizable=yes, scrollbars=yes'); return false;
  }

  return (
    <div className='tos-footer__share' ref={tooltipRef}>
      <button
        className={`tos-footer__button ${classActive}`}
        onClick={shareTooltipHandler}
      >
        <div className='tos-footer__button-icon'>
          <svg
            width='15'
            height='12'
            viewBox='0 0 15 12'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              d='M9.375 3.82357C4.96874 3.82357 1.12499 6.88246 0.0562401 11.2412L0 11.4706C2.4 9.02353 5.66251 7.64706 9.05626 7.64706H9.37499V11.4706L15 5.73529L9.37499 0L9.375 3.82357Z'
              fill='white'
            />
          </svg>
        </div>
        <span>Share</span>
      </button>

      <div
        className={`tos-footer__tooltip tos-footer__tooltip--share ${
          toggleSocialTooltip ? 'tos-footer__tooltip--open' : ''
        }`}
        ref={tooltipShareContentRef}
      >
        <button
          className='tos-footer__tooltip-close'
          onClick={() => settoggleSocialTooltip(false)}
        >
          &times;{' '}
        </button>
        <span className='tos-footer__share-text'>Share this page</span>

        <div className="tos-footer__share-wrapper">
          <ul className='tos-footer__share-social social-list'>
            <li className='social-list--element social-list-element--addthis social-list--element--linkedin'>
              <button
                className='addthis_share_button linkedin'
                data-service='linkedin'
                onClick={() => shareLinkedin()}
              >
                <svg
                  width='20'
                  height='20'
                  viewBox='0 0 20 20'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M18 0H2C0.89543 0 0 0.89543 0 2V18C0 19.1046 0.89543 20 2 20H18C19.1046 20 20 19.1046 20 18V2C20 0.89543 19.1046 0 18 0ZM4 4.56404C4 5.42749 4.70032 6.12899 5.56637 6.12899C6.4297 6.12899 7.13184 5.42749 7.13184 4.56404C7.13184 3.7015 6.4297 3 5.56637 3C4.70123 3 4 3.70059 4 4.56404ZM4.25044 16H6.93695V7.36366H4.25044V16ZM17 16H14.3153V11.8001C14.3153 10.7984 14.2971 9.51001 12.9192 9.51001C11.5213 9.51001 11.3064 10.6009 11.3064 11.7273V16H8.62172V7.36366H11.1989V8.54374H11.2354C11.5942 7.86499 12.4703 7.14894 13.7771 7.14894C16.4973 7.14894 17 8.93771 17 11.2633V16Z'
                    fill='white'
                  />
                </svg>
              </button>
            </li>
            <li className='social-list--element social-list-element--addthis social-list--element--twitter'>
              <button
                className='addthis_share_button twitter'
                data-service='twitter'
                onClick={() => shareTwitter()}
              >
                <svg
                  width='20'
                  height='20'
                  viewBox='0 0 20 20'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M18 0H2C0.89543 0 0 0.89543 0 2V18C0 19.1046 0.89543 20 2 20H18C19.1046 20 20 19.1046 20 18V2C20 0.89543 19.1046 0 18 0ZM15.3502 6.23936C15.9312 6.1722 16.4847 6.02331 17 5.80205C16.615 6.35858 16.1277 6.84744 15.5661 7.23946C15.5715 7.35868 15.5742 7.47842 15.5742 7.59868C15.5742 11.2685 12.686 15.5 7.40283 15.5C5.78051 15.5 4.27126 15.0403 3 14.2526C3.22507 14.2786 3.45391 14.2917 3.68544 14.2917C5.03154 14.2917 6.26995 13.8476 7.25261 13.1026C5.99588 13.0802 4.93516 12.2769 4.56956 11.1737C4.74455 11.2055 4.92493 11.2232 5.10961 11.2232C5.37183 11.2232 5.62598 11.1893 5.86666 11.1258C4.55232 10.8712 3.56267 9.74881 3.56267 8.40302V8.36814C3.94981 8.57587 4.39295 8.70081 4.86354 8.71539C4.09303 8.21769 3.58636 7.36753 3.58636 6.4044C3.58636 5.89472 3.72797 5.41784 3.97458 5.0076C5.39175 6.68813 7.50783 7.79391 9.89474 7.90948C9.84628 7.70697 9.82043 7.49456 9.82043 7.27694C9.82043 5.74374 11.1062 4.5 12.6925 4.5C13.5184 4.5 14.2647 4.83736 14.7886 5.37723C15.4434 5.25228 16.0583 5.02113 16.6129 4.70304C16.3986 5.35172 15.9436 5.89576 15.3502 6.23936Z'
                    fill='white'
                  />
                </svg>
              </button>
            </li>
            <li className='social-list--element social-list-element--addthis social-list--element--facebook'>
              <button
                className='addthis_share_button facebook'
                data-service='facebook'
                onClick={() => shareFacebook()}
              >
                <svg
                  width='20'
                  height='20'
                  viewBox='0 0 20 20'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M18 0H2C0.89543 0 0 0.89543 0 2V18C0 19.1046 0.89543 20 2 20H18C19.1046 20 20 19.1046 20 18V2C20 0.89543 19.1046 0 18 0ZM8 10.4706V18H11V10.4706H13.5629L13.9741 7.64706H11V6.44047C11 5.35812 11.3053 4.82353 12.339 4.82353H14V2.12329L13.9825 2.12097C13.6836 2.08142 13.0684 2 11.925 2C9.48967 2 8 3.26024 8 6.13082V7.64706H5V10.4706H8Z'
                    fill='white'
                  />
                </svg>
              </button>
            </li>
          </ul>
          <div className='tos-footer__share-copy'>
            <textarea
              className='tos-footer__share-url'
              ref={shareUrlRef}
              value={window.location.href}
              readOnly
            />
            <button
              className='tos-footer__share-copy-btn'
              onClick={copyToClipboardHandler}
            >
              {toggleCopyTooltip && (
                <span className='tos-footer__share-text-helper'>Copied</span>
              )}
              copy
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SocialShare;

